import { Button } from 'antd'
import React from 'react'

function ANTDButton({ ...props }) {
  return <Button {...props} />
}

export default ANTDButton
